'use strict';

// import 'core-js/fn/array/find';
import _ from 'underscore';
import config from '../../js/config';
import mediator from '../../js/mediator';
import utilities from '../../js/utilities';
import * as featureFlags from '../../utilities/featureFlags';
import AddToCartModal from './AddToCartModal';
import Cart from './Cart';

export default class CartNotificationView {

  constructor($headerCart) {
    this.$headerCart = $headerCart;
    this.initialize();
  }

  initialize() {
    this.$count = this.$headerCart.find('.u-dot');
    this.initialiseIconCount();
    this.initialiseEvents();
  }

  initialiseIconCount() {
    // Display the cart count from local storage if it exists
    Cart.get().done(_.bind(this.onCartUpdated, this));
  }

  initialiseEvents() {
    // When a product has been added, update the counter
    mediator.on(config.events.cart.added, this.onItemAdded, this);

    // When the cart updates, update the counter
    mediator.on(config.events.cart.updated, this.onCartUpdated, this);
  }

  onCartUpdated(cart) {
    this.setCartNotificationIconCount(cart.cartItemCount, false);
  }

  onItemAdded(cart) {
    this.setCartNotificationIconCount(cart.cartItemCount, true);
    if (featureFlags.AddToCartModal.isEnabled() && !utilities._isMobileOrTabletDevice()) {
      let itemsToAdd = cart.entries.filter((entry) => {
        return cart.addedProducts.find((product) => {
          if (Cart.getCartCatalogSourcePartId(entry) && product.model.sourcePartId) {
            return Cart.getCartCatalogSourcePartId(entry).replace('-AR', '') === product.model.sourcePartId.replace('-AR', '');
          } else {
            return false;
          }
        });
      });

      if (itemsToAdd.length) {
        if (featureFlags.EnableVatPricingMessage.isEnabled()) {
          let isVATCountry = cart.addedProducts[0].model.isVATCountry;
          itemsToAdd.forEach(function(itemToAdd) {
            itemToAdd.isVATCountry = isVATCountry;
          });
        }
        this.popAddToCartModal({
          totalItemsInCart: cart.cartItemCount,
          products: itemsToAdd,
          total: cart.subtotal,
          analyticsConfig: config.analytics
        });
      }
    }
  };

  popAddToCartModal(addToModalData) {
    let modal = new AddToCartModal();
    modal.open(addToModalData);
  };

  setCartNotificationIconCount(count, isFromAdded) {
    if (!count) {
      count = '';
    }

    this.$count.text(count);

    if (count) {
      this.$count.removeClass(config.classes.isHidden);
      if (isFromAdded) {
        // Remove the class once animation has finished
        //
        const animationEndName = utilities.getAnimationEndName();
        this.$count.addClass('u-dot--grow').one(animationEndName, () => {
          this.$count.removeClass('u-dot--grow');
        });
      }
    } else {
      this.$count.addClass(config.classes.isHidden);
    }
  }
}



// WEBPACK FOOTER //
// ./assets/components/Cart/CartNotificationView.js